$.onmount('[data-toggle=selectize]', function () {
  var $el = $(this)

  $el.selectize(Object.assign({
    highlight: false,
    create: false,
    plugins: $el.attr('multiple') ? ['remove_button'] : []
  }, $el.data('options') || {}))
})
